import React, { useMemo } from 'react'
import { RouteObject, useRoutes } from 'react-router-dom'

import LatestTaxCalculation from 'components/ApiTesting/LatestTaxCalculation'
import StartPage from 'components/ApiTesting/StartPage'
import TaxYearEvents from 'components/ApiTesting/TaxYearEvents'
import TaxYearSummary from 'components/ApiTesting/TaxYearSummary'
import Users from 'components/ApiTesting/Users'
import Layout from 'components/Layout'
import ApiCallStoreContext from 'contexts/ApiCallStoreContext'
import ApiCallStore from 'stores/ApiCallStore'

import styles from './index.module.scss'

const ROUTES: RouteObject[] = [
  {
    path: '/',
    element: <StartPage />,
  },
  {
    path: 'users',
    element: <Users />,
  },
  {
    path: 'users/:userId/latestTaxCalculation',
    element: <LatestTaxCalculation />,
  },
  {
    path: 'tax_calculations/:taxCalculationId/years/:year/summary',
    element: <TaxYearSummary />,
  },
  {
    path: 'tax_calculations/:taxCalculationId/years/:year/events',
    element: <TaxYearEvents />,
  },
]

const ApiTesting = () => {
  const store = useMemo(() => new ApiCallStore(), [])

  return (
    <ApiCallStoreContext.Provider value={store}>
      <Layout>
        <div className={styles.apiContainer}>{useRoutes(ROUTES)}</div>
      </Layout>
    </ApiCallStoreContext.Provider>
  )
}

export default ApiTesting
